import { render, staticRenderFns } from "./ERealEstateList.vue?vue&type=template&id=70e360a1&scoped=true&"
import script from "./ERealEstateList.vue?vue&type=script&lang=js&"
export * from "./ERealEstateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e360a1",
  null
  
)

export default component.exports